/* DeVAR product page interactions. Scoped per product section for theme-editor safety. */
(function () {
  function money(cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function initProductPage(root) {
    if (!root || root.dataset.productReady === 'true') return;
    root.dataset.productReady = 'true';

    const jsonNode = root.querySelector('[data-product-json]');
    let product = null;
    try { product = JSON.parse(jsonNode?.textContent || 'null'); } catch (error) { console.error('Unable to read product data', error); }

    const track = root.querySelector('[data-mobile-track]');
    const slides = Array.from(root.querySelectorAll('[data-mobile-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
    const desktopSlides = Array.from(root.querySelectorAll('[data-desktop-slide]'));
    const desktopThumbs = Array.from(root.querySelectorAll('[data-desktop-thumb]'));
    const desktopCurrent = root.querySelector('[data-desktop-current]');
    const dialog = root.querySelector('[data-zoom-dialog]');
    const zoomImage = root.querySelector('.devar-product__zoom-image');
    let activeMedia = Math.max(0, desktopSlides.findIndex((slide) => slide.classList.contains('is-active')));

    function renderDesktop(index) {
      desktopSlides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      desktopThumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
        if (thumbIndex === index) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      if (desktopCurrent) desktopCurrent.textContent = String(index + 1);
    }

    function setActiveMedia(index, openZoom) {
      const safeIndex = Math.max(0, Math.min(Number(index) || 0, slides.length - 1));
      activeMedia = safeIndex;
      renderDesktop(safeIndex);
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === safeIndex));
      if (track && slides[safeIndex]) track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });

      const mediaImage = slides[safeIndex]?.querySelector('img');
      if (mediaImage && zoomImage) {
        zoomImage.src = mediaImage.currentSrc || mediaImage.src;
        zoomImage.alt = mediaImage.alt;
      }
      if (openZoom && dialog?.showModal) dialog.showModal();
    }

    root.querySelectorAll('[data-gallery-media]').forEach((button) => {
      button.addEventListener('click', () => setActiveMedia(button.dataset.mediaIndex, true));
    });
    desktopThumbs.forEach((thumb) => thumb.addEventListener('click', () => setActiveMedia(thumb.dataset.desktopThumb, false)));
    root.querySelector('[data-desktop-prev]')?.addEventListener('click', () => setActiveMedia((activeMedia - 1 + Math.max(desktopSlides.length, 1)) % Math.max(desktopSlides.length, 1), false));
    root.querySelector('[data-desktop-next]')?.addEventListener('click', () => setActiveMedia((activeMedia + 1) % Math.max(desktopSlides.length, 1), false));
    dots.forEach((dot) => dot.addEventListener('click', () => setActiveMedia(dot.dataset.galleryDot, false)));
    root.querySelector('[data-product-zoom]')?.addEventListener('click', () => setActiveMedia(activeMedia, true));
    root.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    if (track && slides.length > 1) {
      let frame = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const next = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          activeMedia = Math.max(0, Math.min(next, slides.length - 1));
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeMedia));
        });
      }, { passive: true });
    }

    root.querySelectorAll('[data-story-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const name = tab.dataset.storyTab;
        root.querySelectorAll('[data-story-tab]').forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        root.querySelectorAll('[data-story-panel]').forEach((panel) => panel.classList.toggle('is-hidden', panel.dataset.storyPanel !== name));
      });
    });

    const qtyText = root.querySelector('#product-qty-val');
    const qtyInput = root.querySelector('#product-quantity-input');
    const businessMode = document.documentElement.classList.contains('business-mode');
    const minimum = businessMode ? Math.max(1, Number(root.dataset.b2bMoq) || 5) : 1;
    function setQuantity(value) {
      const quantity = Math.max(minimum, Number(value) || minimum);
      if (qtyText) qtyText.textContent = String(quantity);
      if (qtyInput) qtyInput.value = String(quantity);
    }
    setQuantity(minimum);
    root.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => setQuantity(Number(qtyInput?.value || minimum) + Number(button.dataset.quantityChange)));
    });

    function selectedVariant() {
      if (!product) return null;
      const selected = Array.from(root.querySelectorAll('.variant-group')).map((group) => group.querySelector('.variant-swatch.active')?.dataset.value);
      return product.variants.find((variant) => selected.every((value, index) => variant['option' + (index + 1)] === value));
    }

    function updateVariant(variant) {
      if (!variant) return;
      const idInput = root.querySelector('#selected-variant-id');
      if (idInput) idInput.value = variant.id;

      root.querySelectorAll('[data-product-price], [data-sticky-price]').forEach((node) => {
        node.textContent = money(variant.price);
        node.setAttribute('data-original-price-text', node.textContent);
      });
      const compare = root.querySelector('[data-product-compare]');
      const discount = root.querySelector('[data-product-discount]');
      const hasDiscount = Number(variant.compare_at_price) > Number(variant.price);
      if (compare) {
        compare.textContent = hasDiscount ? money(variant.compare_at_price) : '';
        compare.classList.toggle('is-hidden', !hasDiscount);
        compare.setAttribute('data-original-price-text', compare.textContent);
      }
      if (discount) {
        const percent = hasDiscount ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        discount.textContent = percent + '% OFF';
        discount.classList.toggle('is-hidden', !hasDiscount);
      }
      root.querySelectorAll('[data-product-sku]').forEach((node) => { node.textContent = variant.sku || '—'; });

      const primaryBuyNow = root.querySelector('[data-primary-buy-now]');
      const stickyBuyNow = root.querySelector('[data-sticky-buy-now]');
      const stock = root.querySelector('[data-stock-availability]');
      [primaryBuyNow, stickyBuyNow].forEach((button) => { if (button) button.disabled = !variant.available; });
      if (primaryBuyNow) primaryBuyNow.querySelector('span').textContent = variant.available ? 'Buy Now' : 'Sold Out';
      if (stickyBuyNow) stickyBuyNow.textContent = variant.available ? 'Buy Now' : 'Sold Out';
      if (stock) stock.innerHTML = variant.available ? '<span>✓ In Stock</span>' : '<span class="is-unavailable">✕ Out of Stock</span>';

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      const mediaIndex = mediaId && product.media ? product.media.findIndex((item) => item.id === mediaId) : -1;
      if (mediaIndex >= 0) setActiveMedia(mediaIndex, false);
      if (typeof window.convertAllPricesOnPage === 'function') window.convertAllPricesOnPage();
    }

    root.querySelectorAll('.variant-swatch').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        swatch.closest('.variant-group')?.querySelectorAll('.variant-swatch').forEach((item) => item.classList.toggle('active', item === swatch));
        updateVariant(selectedVariant());
      });
    });

    function nativeBuyNow() {
      const form = root.querySelector('.devar-product__form');
      if (!form) return;
      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = '/checkout';
      HTMLFormElement.prototype.submit.call(form);
    }

    function launchBuyNow() {
      const fastrrButton = root.querySelector('.shiprocket-headless .sr-headless-checkout');
      if (fastrrButton && !fastrrButton.disabled) {
        fastrrButton.click();
        return;
      }
      nativeBuyNow();
    }

    root.querySelectorAll('[data-buy-now-proxy]').forEach((button) => button.addEventListener('click', launchBuyNow));

    const postcode = root.querySelector('[data-delivery-postcode]');
    const deliveryMessage = root.querySelector('[data-delivery-message]');
    root.querySelector('[data-delivery-check]')?.addEventListener('click', () => {
      const valid = /^\d{6}$/.test(postcode?.value.trim() || '');
      if (deliveryMessage) deliveryMessage.textContent = valid ? 'Delivery options for this PIN code will be confirmed at checkout.' : 'Please enter a valid 6-digit PIN code.';
      postcode?.setAttribute('aria-invalid', String(!valid));
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-product-root]').forEach(initProductPage); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
